import React from "react";
import ExploreDirectory from "../explore-directory/explore-directory";

export const Explore = (props) => {
  return <ExploreDirectory />;
};
